import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import FormPopup from "../common/popup/form-popup";
import TermsArticle from "../terms/terms-article";
import PrimaryButton from "../button/primary-btn";
import { acceptTermsUpdate } from "../../reducers/userReducer";

const TermsUpdateModal = () => {
  const dispatch = useDispatch();
  const { detail, isAcceptingTerms } = useSelector((state) => state.user);
  const shouldForceOpen =  Boolean(detail?.terms_update_required);
  const [isOpen, setIsOpen] = useState(false);
  const [hasScrolledToEnd, setHasScrolledToEnd] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => {
    if (shouldForceOpen) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [shouldForceOpen]);

  useEffect(() => {
    if (!isOpen) {
      setHasScrolledToEnd(false);
    }
  }, [isOpen]);

  const updateScrollProgress = useCallback(() => {
    const node = contentRef.current;
    if (!node) {
      return;
    }

    const { scrollTop, scrollHeight, clientHeight } = node;
    if (scrollHeight <= clientHeight) {
      setHasScrolledToEnd(true);
      return;
    }

    const isEndReached = scrollTop + clientHeight >= scrollHeight - 8;
    if (isEndReached) {
      setHasScrolledToEnd(true);
    }
  }, []);

  useEffect(() => {
    if (!isOpen) {
      return;
    }

    updateScrollProgress();
  }, [isOpen, updateScrollProgress]);

  const handleConfirm = async () => {
    try {
      await dispatch(acceptTermsUpdate()).unwrap();
      setIsOpen(false);
    } catch (error) {
      toast.error(error?.message ?? "Errore durante l'accettazione dei termini.");
    }
  };

  return (
    <FormPopup
      title="Termini e condizioni aggiornati"
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      showHeader
      isActiveCloseBack={false}
      defaultWith="max-w-5xl"
      isActiveFormPm={false}
      showCloseButton={false}
    >
      <div className="flex flex-col gap-6 px-6 py-4">
        <p className="text-sm text-gray-700">
          Scorri fino in fondo per poter confermare la presa visione dei nuovi
          termini.
        </p>
        <div
          ref={contentRef}
          onScroll={updateScrollProgress}
          className="max-h-[65vh] overflow-y-auto pr-4"
        >
          <TermsArticle className="pr-4" />
        </div>
        <PrimaryButton
          label="Conferma"
          onClick={handleConfirm}
          disabled={!hasScrolledToEnd || isAcceptingTerms}
          isLoading={isAcceptingTerms}
          LoadingLabel="Invio in corso..."
          isFullWith
        />
      </div>
    </FormPopup>
  );
};

export default TermsUpdateModal;
